<ion-header>
    <ion-toolbar>
        <ion-title> {{ 'Log in with ITA credentials' | translate }}</ion-title>
        <ion-buttons slot="end">
            <ion-button (click)="dismiss()" slot="end">
                <ion-icon slot="icon-only" name="close"></ion-icon>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>
</ion-header>

<ion-content>
    <div class="image">
        <img src="/assets/img/ita-logo.png" alt="ita logo">
    </div>
    <form [formGroup]="form" (ngSubmit)="onSubmit()">
        <ion-list class="content-width">
            <ion-item>
                <ion-label position="floating"> {{ 'Email' | translate }}</ion-label>
                <ion-input required formControlName="username" type="text" name="ItaEmail"></ion-input>
            </ion-item>

            <ion-item>
                <ion-label position="floating"> {{ 'Password' | translate }}</ion-label>
                <ion-input required formControlName="password" type="password" name="ItaPassword"></ion-input>
            </ion-item>
        </ion-list>
    </form>
</ion-content>
<ion-footer>
    <ion-toolbar>
        <ion-button (click)="onSubmit()" class="ion-margin" expand="block" color="primary" type="submit">
            <span [hidden]="isSubmitting">{{ 'Login' | translate }}</span>
            <ion-spinner [hidden]="!isSubmitting" name="crescent"></ion-spinner>
        </ion-button>
    </ion-toolbar>
</ion-footer>